import { LineChart } from 'components/LineChart/LineChart'
import Chart from 'components/Chart/Chart'
import { ContentWidth, TextWidth } from 'components/Container'
import { MapBoxMap } from 'components/MapBoxMap'
import { useMFContext } from 'components/MFHelpers'
import StatsDisplay from 'components/StatsDisplay'
import { LngLatBoundsLike } from 'mapbox-gl'
import { useEffect, useState } from 'react'
import { renderToString } from 'react-dom/server'
import styled from 'styled-components'
import { GdeDataType } from 'Types/MicroFrontendProps'
import mapboxgl from 'mapbox-gl'
import ColorKey from 'components/ColorKey'
import { bbox, bboxPolygon, buffer } from '@turf/turf'
import MunicipalitySearch from '@ta-interaktiv/react-municipality-search'
const gdedata = require('./gdedata.json') as GdeDataType[]

const style = 'mapbox://styles/ta-interaktiv/cm8svtb1s00gj01sk2l622b5k'
const tenantGdes = {
  tagesanzeiger: 261,
  '24heures': 5586,
  bazonline: 2701,
  berneroberlaender: 351,
  bernerzeitung: 351,
  bilan: 6621,
  derbund: 351,
  landbote: 230,
  langenthalertagblatt: 351,
  tdg: 6621,
  thunertagblatt: 942,
  zsz: 261,
  zuonline: 261,
}
const tenantGdeNames = {
  tagesanzeiger: 'Zürich',
  '24heures': 'Lausanne',
  bazonline: 'Basel',
  berneroberlaender: 'Bern',
  bernerzeitung: 'Bern',
  bilan: 'Bern',
  derbund: 'Bern',
  landbote: 'Winterthur',
  langenthalertagblatt: 'Bern',
  tdg: 'Genève',
  thunertagblatt: 'Thun',
  zsz: 'Zürich',
  zuonline: 'Zürich',
}
const MainPart = () => {
  const [settlementLabels, setSettlementLables] = useState<any>()
  const { currentLanguage, colorMode, isMobile, _t, tenantKey } = useMFContext()
  const dataYear = 2025
  const [currentBBox, setCurrentBbox] = useState<number[][]>()
  const [currentGde, setCurrentGde] = useState<GdeDataType>()
  const [currentGdeName, setCurrentGdeName] = useState<string>(
    tenantGdeNames[tenantKey]
  )
  const [currentGdeNr, setcurrentGdeNr] = useState<number>(
    tenantGdes[tenantKey]
  )
  const [currentView, setCurrentView] = useState<number[][]>()
  const [map, setMap] = useState<mapboxgl.Map>()
  const [mask, setMask] = useState<any>()
  const [lineChartData, setLineChartData] = useState<any>()
  const [statsData, setStatsData] = useState<any>()
  function prepLineChartData(data: any) {
    const prepped = [[], [], []]
    data.year.map((year: number, i: number) => {
      prepped[2].push({ year, value: data.gde_data[i] })
      prepped[1].push({ year, value: data.kt_data[i] })
      prepped[0].push({ year, value: data.ch_data[i] })
    })
    return prepped
  }

  function prepStatsData(data: any) {
    console.log({ data })
    const prepped = {
      power: data.total_production,
      count: data.numberPlants,
      ratio: data.potential_used * 100,
      name: data.name,
    }
    return prepped
  }

  //fetch Muni-Data from Url
  useEffect(() => {
    fetch(
      'https://interaktiv.tagesanzeiger.ch/2025/solar/munis/' +
        currentGdeNr +
        '.json'
    )
      .then((res) => res.json())
      .then((data) => {
        const prepped = prepLineChartData(data)
        setLineChartData(prepped)
        const preppedStats = prepStatsData(data)
        setStatsData(preppedStats)
      })
  }, [currentGdeNr])

  /*
   Change Municipality
   */
  useEffect(() => {
    if (!currentGde) return
    if (currentGde) {
      if (isMobile) {
        const box = currentGde.vie.flat() as [number, number, number, number]
        const bboxPoly = bbox(
          buffer(bboxPolygon([box[0], box[1], box[2], box[3]]), 2000, {
            units: 'meters',
          })
        )
        setCurrentView([bboxPoly])
      } else {
        setCurrentView(currentGde.vie)
      }
      setCurrentBbox(currentGde.bbo)
      handleGdeChange()
    }
  }, [currentGde, mask, map, settlementLabels])

  /*

    change mask color on colormode change

  */
  useEffect(() => {
    if (!map) return
    map.setPaintProperty(
      'mask',
      'fill-color',
      colorMode === 'light' ? '#fff' : '#121212'
    )
  }, [colorMode])

  // Get City Label Data
  useEffect(() => {
    if (!map) return
    fetch(
      'https://interaktiv.tagesanzeiger.ch/static/2022/solar-karte/settlements.json'
    )
      .then((a) => a.json())
      .then((settlementLabels) => {
        setSettlementLables(settlementLabels)
      })
  }, [map])
  /*
Load Municipality mask
  */
  useEffect(() => {
    /*

  Find gde with gde number in gdedata

  */
    if (!currentGdeNr) return
    fetch(
      'https://interaktiv.tagesanzeiger.ch/static/2025/solar-karte/' +
        currentGdeNr +
        '.json'
    )
      .then((a) => a.json())
      .then((mask) => {
        console.log('MASK', mask)
        setMask(mask)
      })
    let gde: GdeDataType | undefined = gdedata.find(
      (f) => f.gde === +currentGdeNr
    )

    if (!gde) return
    setCurrentGde(gde)
  }, [currentGdeNr])
  function setSelectedMunicipality(municipality: any) {
    setcurrentGdeNr(municipality.GDENR)
    console.log('MUNICIPALITY', municipality)
    setCurrentGdeName(municipality.NORMGEMEINDE)
  }

  const handleGdeChange = () => {
    if (!map || !currentGde) return
    const solarfilter = [
      'all',
      ['match', ['get', 'gde'], [+currentGde.gde], true, false],
    ]
    /*

    Change gde mask

    */
    const doMapChanges = () => {
      if (!isValidGeoJSON(mask)) return

      const makslayersource = map.getSource('mask') as mapboxgl.GeoJSONSource
      makslayersource.setData(mask)
      // toggle solar circles layer
      map.setLayoutProperty('solar-sizes', 'visibility', 'visible')
      // filter solar circles for current municipalit
      map.setFilter('solar-sizes', solarfilter)
      // set max bounds for current municipality
      map.setMaxBounds(currentGde.bbo as LngLatBoundsLike)
      // fit current municipality on screnn
      map.fitBounds(currentGde.vie as LngLatBoundsLike)
      // filter settlement labels for current municipality
      if (map.getSource('settlements'))
        map.setFilter('settlements', solarfilter)
      // scale circles for current municipality
      if (
        currentGde &&
        currentGde.rad &&
        currentGde.rad[0] &&
        currentGde.rad[1]
      )
        map.setPaintProperty('solar-sizes', 'circle-radius', [
          'interpolate',
          ['linear'],
          ['get', 'rad'],
          currentGde.rad[0],
          5,
          currentGde.rad[1],
          isMobile ? 10 : 30,
        ])
    }
    // faster trigger for first load when map receives style data
    map.once('styledata', () => {
      doMapChanges()
    })
    // on municipality change trigger when map is idle
    map.once('idle', () => {
      doMapChanges()
    })
  }
  return (
    <>
      <TextWidth>
        <SearchContainer>
          <SearchTitle>{_t('search_your_municipality')}</SearchTitle>
          <MunicipalitySearch
            locale={currentLanguage === 'de' ? 'de' : 'fr'}
            resetOnSelect
            municipalityData={
              currentLanguage === 'de'
                ? '20250101_de_nozip'
                : '20250101_fr_nozip'
            }
            onSelectionHandler={setSelectedMunicipality}
          />
        </SearchContainer>
      </TextWidth>
      <ContentWidth>
        {statsData && <StatsDisplay data={statsData} name={currentGdeName} />}
        <Disclaimer>{_t('sat_disclaimer')}</Disclaimer>
        {currentGdeNr && (
          <MapBoxMap
            dataYear={dataYear}
            language={currentLanguage}
            panAllowed
            dataSource={
              currentLanguage === 'de' ? 'BFE, SwissTopo' : 'OFEN, SwissTopo'
            }
            maxExtendBounds={currentBBox}
            viewBounds={currentView}
            init={(map: mapboxgl.Map) => {
              setMap(map)

              map.once('styledata', () => {
                map.on('click', 'solar-sizes', (e) => {
                  // Copy coordinates array.
                  const coordinates =
                    e.features[0].geometry['coordinates'].slice()
                  const props = e.features[0].properties

                  new mapboxgl.Popup({
                    closeButton: false,
                    className: 'popppp',
                  })

                    .setLngLat(coordinates)
                    .setHTML(
                      renderToString(
                        <PopUp
                          year={props.year}
                          power={+props.pow}
                          language={currentLanguage}
                        />
                      )
                    )
                    .addTo(map)
                })
              })
              map.on('styledata', function () {
                let s = map.getSource('mask')
                if (!s)
                  map.addSource('mask', {
                    type: 'geojson',
                    data: {
                      type: 'Feature',
                      properties: {},
                      geometry: {
                        type: 'Polygon',
                        coordinates: [
                          [
                            [-180, -90],
                            [-180, 90],
                            [180, 90],
                            [180, -90],
                            [-180, -90],
                          ],
                        ],
                      },
                    },
                  })

                let l = map.getLayer('mask')
                if (!l)
                  map.addLayer(
                    {
                      id: 'mask',
                      type: 'fill',
                      source: 'mask',
                      layout: {},
                      paint: {
                        'fill-color':
                          colorMode === 'light' ? '#fff' : '#121212',
                        'fill-opacity': 1,
                      },
                    },
                    'solar-sizes'
                  )
              })
            }}
            config={{
              dragRotate: true,
              pitch: 50,
              style: style,
            }}
          />
        )}
      </ContentWidth>
      {lineChartData && (
        <Chart
          meta={{
            title: _t('linechart_title', { name: currentGdeName }),
            subtitle: _t('linechart_subtitle'),
            hint: _t('linechart_hint'),
            source: (
              <>
                {_t('source')}:{' '}
                <a href='https://www.uvek-gis.admin.ch/BFE/storymaps/EE_Elektrizitaetsproduktionsanlagen/'>
                  {_t('linechart_source')}
                </a>
              </>
            ),
          }}
          addToHead={
            <ColorKey
              data={[
                [
                  {
                    color:
                      colorMode === 'light' ? 'var(--gray-4)' : 'var(--gray-3)',
                    label: _t('switzerland') as string,
                    type: 'line',
                  },
                  {
                    color:
                      colorMode === 'light' ? 'var(--gray-2)' : 'var(--gray-5)',
                    label: _t('canton') as string,
                    type: 'line',
                  },
                  {
                    color: '#ffcf31',
                    label: _t('muni') as string,
                    type: 'line',
                  },
                ],
              ]}
            />
          }
          contentWidth='TextWidth'
        >
          <LineChart data={lineChartData} />
          <div
            style={{
              display: 'none',
            }}
          >
            <PopUp year={2025} power={100} language={currentLanguage} />
          </div>
        </Chart>
      )}
    </>
  )
}
const MainPartContainer = styled.div``

export default MainPart

const Disclaimer = styled.div`
  font-size: 10px;
  line-height: 1.4em;
  font-weight: 500;
  max-width: 668px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  letter-spacing: 0.05em;
  color: var(--gray-3);
  font-style: italic;
  padding: 20px;
`

function isValidGeoJSON(data: any) {
  try {
    // Check basic structure
    if (!data || typeof data !== 'object') return false

    // Check for required type property
    if (!data.type) return false

    // For FeatureCollection
    if (data.type === 'FeatureCollection') {
      return Array.isArray(data.features)
    }

    // For Feature
    if (data.type === 'Feature') {
      return data.geometry && data.geometry.type && data.geometry.coordinates
    }

    // For direct geometry
    return data.coordinates && Array.isArray(data.coordinates)
  } catch (e) {
    console.error('GeoJSON validation error:', e)
    return false
  }
}

const PopUp = ({
  year,
  power,
  language,
}: {
  year: number
  power: number
  language: 'de' | 'fr' | undefined
}) => {
  const Labels = {
    de: { year: 'Baujahr', power: 'Leistung', unit: 'kWp' },
    fr: { year: 'Année de construction', power: 'Puissance', unit: 'kWc' },
  }
  return (
    <StyledPopUp>
      <div className='row'>
        <label>{Labels[language].year}:</label> <b>{year}</b>
      </div>
      <div className='row'>
        <label>{Labels[language].power}:</label>{' '}
        <b>
          {power}
          {Labels[language].unit}
        </b>
      </div>
    </StyledPopUp>
  )
}
const StyledPopUp = styled.div`
  color: #000;

  font-size: 14px;
  line-height: 1.4em;
  font-family: var(--font-sans-serif);
  font-weight: 500;
  .row {
    width: 100%;
  }
  label {
    /* font-size: 12px; */
    font-weight: 400;
    margin-right: 1em;
  }
`

const SearchContainer = styled.div`
  position: relative;
  z-index: 1010;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding-bottom: 30px;
  padding-top: 30px;
  color: var(--text-color);
`
const SearchTitle = styled.div`
  font-size: 22px;
  line-height: 2em;
  font-weight: 500;
  margin-bottom: 10px;
  font-family: var(--font-sans-serif);
  font-weight: 900;
`
